import React from "react";
import { useSelector } from "react-redux";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import SnapshotsDropdownOption from "layout/discovery/header/snapshots/SnapshotsDropdownOption";

const SnapshotsDropdown = () => {
  const snapshots = useSelector((state) => state.discovery.snapshots);

  return (
    <Dropdown
      type={dropdownTypes.buttons}
      propsObject={{
        button: <span>Snapshots ({snapshots.length}) </span>,
        disabled: snapshots.length === 0,
        buttonVariant: buttonVariants.borderless,
        hideArrowIcon: false,
        options: snapshots.map(({ name, author }) => (
          <SnapshotsDropdownOption name={name} author={author} />
        )),
        optionListClassName:
          "discovery_snapshots_controls__dropdown_option_list",
      }}
    />
  );
};

export default SnapshotsDropdown;
